import { useToast } from "@commonlibs";
import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import useTranslate from "ui/locale/hooks/useTranslate";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { giftcardsApi } from "../api/giftcardsApi";

export default function useDeleteGiftCard({
    onSuccess,
    ...options
}: UseCustomMutationOptions<void, unknown, string>): UseMutationResult<void, unknown, string> {
    const translate = useTranslate();
    const { showToast } = useToast();
    const queryClient = useQueryClient();

    const handleOnSuccess = (data: void, variables: string, context: unknown) => {
        showToast(translate("giftCardDeletedSuccessfully"), { type: "success" });
        queryClient.invalidateQueries(Queries.GIFTCARDS_FIND_ALL);
        onSuccess?.(data, variables, context);
    };

    return useMutation(
        async (id: string) => {
            await giftcardsApi.deleteLocalGiftCard(id);
        },
        {
            onSuccess: handleOnSuccess,
            ...options,
        },
    );
}
